'use client'
import { jsx } from 'react/jsx-runtime';
import { ChainEnum } from '@dynamic-labs/sdk-api-core';
import { EvmNetworkControl } from '../EvmNetworkControl/EvmNetworkControl.js';
import { NetworkControlSkeleton } from '../NetworkControlSkeleton/NetworkControlSkeleton.js';
import { NonNetworkSwitchingSupportedControl } from '../NonNetworkSwitchingSupportedControl/NonNetworkSwitchingSupportedControl.js';

const NetworkControl = ({ loading, walletConnector, buttonClassName, network, evmNetworks, activeClassName, isOpen, setIsOpen, showNetworkName, }) => {
    // Checks when switching to EVM if the network is still loading.
    // if network is a string the user is switching chains
    // this prevents the network control from flickering
    const chainSwitchLoading = (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) === ChainEnum.Evm &&
        typeof network === 'string';
    if (loading || chainSwitchLoading) {
        return jsx(NetworkControlSkeleton, { className: buttonClassName });
    }
    else if ((walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) &&
        !walletConnector.supportsNetworkSwitching()) {
        return (jsx(NonNetworkSwitchingSupportedControl, { className: buttonClassName, showNetworkName: showNetworkName, walletConnector: walletConnector }));
    }
    else {
        return (jsx(EvmNetworkControl, { showNetworkName: showNetworkName, evmNetworks: evmNetworks, activeClassName: activeClassName, className: buttonClassName, network: network, loading: loading, isOpen: isOpen, walletConnector: walletConnector, setIsOpen: setIsOpen }));
    }
};

export { NetworkControl };
